import React, { useState } from 'react';
import './WhatsAppWidget.css';

const WhatsAppWidget = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [message, setMessage] = useState('Hi I Need Information Of Product This Website?');

  const handleSend = (e) => {
    e.preventDefault();
    if (!message.trim()) return;
    
    // Redirect to wa.me with company number + message content
    const cleanNumber = '919597528585';
    const waUrl = `https://wa.me/${cleanNumber}?text=${encodeURIComponent(message)}`;
    window.open(waUrl, '_blank', 'noopener,noreferrer');
    
    // Optional: Close widget after sending
    setIsOpen(false);
  };

  return (
    <div className="whatsapp-widget-container">
      {/* Chat Popup Panel */}
      <div className={`whatsapp-chat-panel glass ${isOpen ? 'open' : ''}`}>
        {/* Header */}
        <div className="whatsapp-chat-header">
          <div className="whatsapp-header-info">
            <div className="whatsapp-avatar">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
                <path strokeLinecap="round" strokeLinejoin="round" d="M17.982 18.725A7.488 7.488 0 0012 15.75a7.488 7.488 0 00-5.982 2.975m11.963 0a9 9 0 10-11.963 0m11.963 0A8.966 8.966 0 0112 21a8.966 8.966 0 01-5.982-2.275M15 9.75a3 3 0 11-6 0 3 3 0 016 0z" />
              </svg>
              <span className="online-indicator-dot"></span>
            </div>
            <div className="whatsapp-header-text">
              <h4>PallyWear Support</h4>
              <span className="whatsapp-status">Online • Typically replies instantly</span>
            </div>
          </div>
          <button 
            type="button" 
            className="whatsapp-close-btn" 
            onClick={() => setIsOpen(false)}
            aria-label="Close chat"
          >
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
              <line x1="18" y1="6" x2="6" y2="18"></line>
              <line x1="6" y1="6" x2="18" y2="18"></line>
            </svg>
          </button>
        </div>

        {/* Chat Body Area */}
        <div className="whatsapp-chat-body">
          {/* Company Greeting Bubble */}
          <div className="whatsapp-msg msg-received">
            <p>Hello! Welcome to PallyWear. Let us know what you need help with, and click the send button below to chat with us directly on WhatsApp!</p>
            <span className="msg-time">Just now</span>
          </div>

          {/* Live Preview User Bubble */}
          {message.trim() && (
            <div className="whatsapp-msg msg-sent">
              <p>{message}</p>
              <span className="msg-time">Preview</span>
            </div>
          )}
        </div>

        {/* Footer / Send Form */}
        <form onSubmit={handleSend} className="whatsapp-chat-footer">
          <input
            type="text"
            className="whatsapp-chat-input"
            value={message}
            onChange={(e) => setMessage(e.target.value)}
            placeholder="Type a message..."
            required
          />
          <button type="submit" className="whatsapp-send-btn" aria-label="Send WhatsApp message">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
              <line x1="22" y1="2" x2="11" y2="13"></line>
              <polygon points="22 2 15 22 11 13 2 9 22 2"></polygon>
            </svg>
          </button>
        </form>
      </div>

      {/* Trigger floating button */}
      <button 
        type="button" 
        className={`whatsapp-floating-btn ${isOpen ? 'chat-active' : ''}`}
        onClick={() => setIsOpen(!isOpen)}
        aria-label="Open WhatsApp support chat"
      >
        {isOpen ? (
          <svg className="close-widget-icon" width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <line x1="18" y1="6" x2="6" y2="18"></line>
            <line x1="6" y1="6" x2="18" y2="18"></line>
          </svg>
        ) : (
          <svg className="whatsapp-logo-icon" viewBox="0 0 448 512" width="30" height="30" fill="currentColor">
            <path d="M380.9 97.1C339 55.1 283.2 32 223.9 32c-122.4 0-222 99.6-222 222 0 39.1 10.2 77.3 29.6 111L0 480l117.7-30.9c32.4 17.7 68.9 27 106.1 27h.1c122.3 0 224.1-99.6 224.1-222 0-59.3-25.2-115-67.1-157zm-157 341.6c-33.2 0-65.7-8.9-94-25.7l-6.7-4-69.8 18.3L72 359.2l-4.4-7c-18.5-29.4-28.2-63.3-28.2-98.2 0-101.7 82.8-184.5 184.6-184.5 49.3 0 95.6 19.2 130.4 54.1 34.8 34.9 56.2 81.2 56.1 130.5 0 101.8-84.9 184.6-186.6 184.6zm101.2-138.2c-5.5-2.8-32.8-16.2-37.9-18-5.1-1.9-8.8-2.8-12.5 2.8-3.7 5.6-14.3 18-17.6 21.8-3.2 3.7-6.5 4.2-12 1.4-32.6-16.3-54-29.1-75.5-66-5.7-9.8 5.7-9.1 16.3-30.3 1.8-3.7.9-6.9-.5-9.7-1.4-2.8-12.5-30.1-17.1-41.2-4.5-10.8-9.1-9.3-12.5-9.5-3.2-.2-6.9-.2-10.6-.2-3.7 0-9.7 1.4-14.8 6.9-5.1 5.6-19.4 19-19.4 46.3 0 27.3 19.9 53.7 22.6 57.4 2.8 3.7 39.1 59.7 94.8 83.8 13.3 5.7 23.6 9.2 31.6 11.7 11.5 3.7 22 3.1 30.2 1.9 9.2-1.4 28.7-11.7 32.8-23 4.1-11.3 4.1-21 2.9-23-1.2-2-4.5-3.2-10-6z"/>
          </svg>
        )}
      </button>
    </div>
  );
};

export default WhatsAppWidget;
